import { designVariables } from "@studio3t/design-variables";
import {
  BadgeInfoSubtle,
  ButtonMediumSubtleLeadingIcon,
  Icon,
} from "@studio3t/generic-components";
import styled from "styled-components";
import { JobStatusBadge } from "@/components/JobStatusBadge";
import { OpenPipelineMenu } from "./OpenPipelineMenu";
import { usePipelineStaging } from "./pipelineStaging";
import { useStudioPipeline } from "./StudioPipelineProvider";

// The header's center group: the open pipeline's identity and lifecycle
// badge, per state (Figma 14894-169764, deployed 14895-206038). Scratch
// shows just the "Open pipeline" trigger plus Clear; a draft adds its name
// to the trigger and a "draft" badge; a deployed pipeline swaps that badge
// for its live JobStatusBadge. Clear sits right of the badge in every
// state: on a deployed pipeline it closes it and returns the studio to
// scratch — the job itself is untouched (stop/start/duplicate live in the
// right-side group).

// ── Controls ──────────────────────────────────────────────

function ClearButton({
  disabled,
  onClear,
}: {
  disabled: boolean;
  onClear: () => void;
}) {
  return (
    <ButtonMediumSubtleLeadingIcon
      text="Clear and start fresh"
      icon={Icon.Clean}
      disabled={disabled}
      onClick={onClear}
    />
  );
}

// ── The controls row ──────────────────────────────────────

export function WorkspaceControls() {
  const { pipelineDirty } = usePipelineStaging();
  const { openPipeline, jobControl, clearToScratch } = useStudioPipeline();

  return (
    <Group>
      <OpenPipelineMenu />
      {openPipeline?.kind === "draft" && (
        <BadgeInfoSubtle>draft</BadgeInfoSubtle>
      )}
      {openPipeline?.kind === "deployed" && jobControl && (
        <JobStatusBadge state={jobControl.displayState} />
      )}
      <ClearButton disabled={!pipelineDirty} onClear={clearToScratch} />
    </Group>
  );
}

const Group = styled.div`
  display: flex;
  align-items: center;
  gap: ${designVariables.ui.semantic.spacings}px;
`;
